import React from "react"
import { Outlet } from "react-router-dom"
import { Panel } from "rsuite"
import { useNavigate } from "react-router-dom"
import {
    useTheme,
    useMediaQuery
} from "@mui/material"

export default function AuthStack() {
    const theme = useTheme()
    const isMobile = useMediaQuery(theme.breakpoints.down("md"))
    const navigate = useNavigate()
    React.useEffect(() => {
        const user = localStorage.getItem("current_user")
        if (!user) {
            navigate("/auth/signup")
        } else {
            navigate("/auth/login")
        }
    }, [])
    return (
        <div className="col-md-12"
            style={{
                display: "flex",
                justifyContent: "center",
                padding: !isMobile && 20,
                flexDirection: "column",
                width: "100%"
            }}
        >
            <Panel
                style={{
                    padding: 0
                }}
                className="col-md-12"
            >
                <Outlet />
            </Panel>
        </div>
    )
}
